// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__a1qPx","inner":"Footer_inner__1W3So","nextIcon":"Footer_nextIcon__1jGDj","innerLeft":"Footer_innerLeft__1rKAB"};